import React from 'react';
import ReactLoading from 'react-loading';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Modal from 'react-bootstrap/Modal';
import { useAlert } from 'react-alert';
import auth from './auth';

export const Points = props => {
    //Stores the points data as a state
    let [pointsPoolData, setPointsPoolData] = React.useState('');
    let [pointsPoolTableRow, setPointsPoolTableRow] = React.useState([]);
    let [freeProductsTableRow, setFreeProductsTableRow] = React.useState([]);

    const [hideProducts, setHideProducts] = React.useState(true);

    const [notLoading, setNotLoading] = React.useState(true);

    const [tierPercent, setTierPercent] = React.useState(0);
    const [bronzeGoal, setBronzeGoal] = React.useState('goal');
    const [silverGoal, setSilverGoal] = React.useState('goal');
    const [goldGoal, setGoldGoal] = React.useState('goal');
    const [platinumGoal, setPlatinumGoal] = React.useState('goal');
    const [diamondGoal, setDiamondGoal] = React.useState('goal');


    //Offers modal
    const [showModal, setShowModal] = React.useState(false);
    const [modalDescription, setModalDescription] = React.useState("");
    const [modalExpiry, setModalExpiry] = React.useState("");
    const [modalHeading, setModalHeading] = React.useState("");

    const [width, setWidth] = React.useState(window.innerWidth);

    const handleResize = () =>{
      setWidth(window.innerWidth);
    }
    React.useEffect(()=>{
      window.addEventListener("resize", handleResize, false);
    }, []);

    //Gets the members points pool
    React.useEffect(() => {
      if('parentIFrame' in window){
        window.parentIFrame.scrollTo(0, 0);
      }

      setNotLoading(false);
        fetch(localStorage.getItem('server') + 'lookup', {
          method: 'GET',
          headers: {
            'token': sessionStorage.getItem('token'),
            'memberNumber' : sessionStorage.getItem('memberNumber')
          }
        })
        .then(function(response){
          return response.json();
        })
        .then(function(data){
          if(data.status === 401){
            // console.log("Invalid Token - Redirecting to login");
            // props.history.push("");
            alert.show(
              <span ref={sessionRef}>
                  Your session has expired. Please login to continue.
              </span>
              , {
                  title: "Session Expired"
          });
          } else if(data.status === 429){
            alert.show(
                <span ref={sessionRef}>
                    Too many requests. Please try again later.
                </span>
                , {
                    title: "Uh Oh..."
            });
        }else if(data.status === 500){
            //Display error if the member is current
            if(auth.getCurrent() !== "Current"){
              alert.show(
                <span ref={redirectHome}>
                  Your membership is currently inactive. Please contact the club at 02 9722 9888 for assistance.
                </span>
              )
            } else {
              //If the response returns a 500, display a error message
              alert.show(
                <span ref={redirectHome}>
                  We are unable to retrieve your details at the moment. Please try again later.
                </span>
              )
            }
          } else {
            setPointsPoolData(data.data);
            //console.info(data);
            setPointsPoolTableRow(data.data.point_pools);
            setTierPercent(data.data.tier_percent);
            // setTierPercent(75);
            // setFreeProductsTableRow(data.data.freeProducts.Items);
            if(data.data.freeProducts.Items){
              var tempArr = [];
              // console.log(new Date());
              data.data.freeProducts.Items.forEach(function(product){
                //If the product is not redeemed and hasnt expired, then display the product
                if(!product.IsRedeemed && (new Date(product.ExpiryDate) > new Date())){
                  //If no products are available, then hide the whole table
                  product.DateIssued = new Date (product.DateIssued).toLocaleString('en-AU', {dateStyle: 'long'});
                  product.ExpiryDate = new Date (product.ExpiryDate).toLocaleString('en-AU', {dateStyle: 'long'});
                  setHideProducts(false);
                  tempArr.push(product);
                }
              });
              setFreeProductsTableRow(tempArr);
            }
            setNotLoading(true);
          }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
      if(tierPercent >= 20){
        setBronzeGoal('goal bronze-goal');
      }
      if(tierPercent >= 40){
        setSilverGoal('goal silver-goal');
      }
      if(tierPercent >= 60){
        setGoldGoal('goal gold-goal');
      }
      if(tierPercent >= 80){
        setPlatinumGoal('goal platinum-goal')
      }
      if(tierPercent >= 100){
        setDiamondGoal('goal diamond-goal')
      }
    }, [tierPercent ,setTierPercent])

    const alert = useAlert();

    const redirectHome = () =>{
      props.history.push('/home')
    }

    const sessionRef = (node)=>{
      if(node === null){
        window.location.replace(window.location.origin);
      }
    }

    const hideModal = () =>{
      setShowModal(false);
    };

    const openModal = (description, heading, expiry = null) =>{
      setModalDescription(description);
      setModalHeading(heading);
      setModalExpiry(expiry);
      setShowModal(true);
    };

    return(
      <div>
        <div className="overlay" hidden={notLoading}>
          <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300}/>
        </div>
        <div className="container pointsPage">
          <h2 className='text-center'><strong>Points</strong></h2>
          <p className='text-justify'>Be sure to use your points before they expire! Enjoy them at any of our associated venues.</p>

          <table className='table table-striped pointsTable'>
            <thead>
              <tr className='tableHeadRow'>
                <th className='text-center align-middle'>Point Pool</th>
                <th className='text-center align-middle'>Available Points</th>
                <th className='text-center align-middle'>Expiry Date</th>
              </tr>
            </thead>
            <tbody>
              
            {pointsPoolTableRow.map((obj, i) => 
              <tr key={i}>
                <td className='text-center align-middle'>{obj.pool_name}</td>
                <td className='text-center align-middle'>${obj.pool_value}</td>
                <td className='text-center align-middle'>{obj.pool_expiry}</td>
              </tr>
            )}

              <tr>
                <td className='text-center font-weight-bold align-middle'>Total Points</td>
                <td className='text-center font-weight-bold align-middle'>${pointsPoolData.total_points}</td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <br/>

          <Modal show={showModal} onHide={hideModal} centered>
              <Modal.Header className="modal-center">
                <div>
                  <h3 className="remove-bottom-margin">{modalHeading}</h3>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="text-center">
                  <p className="remove-bottom-margin">{modalDescription}</p>
                  <br/>
                  {modalExpiry != null &&
                  <p className="remove-bottom-margin">Expires: {modalExpiry}</p>
                  }
                  <button className="form-btn btn btn-primary formButton" onClick={hideModal}>Close</button>
                </div>
              </Modal.Body>
          </Modal>

          {(hideProducts === false && width > 560) ?
          <div>
            <h3 className="text-center"><strong>Offers</strong></h3>
            <table className="table table-striped pointsTable">
                <thead>
                  <tr className="tableHeadRow">
                    <th className="text-center align-middle">Offer</th>
                    <th className="text-center align-middle">Awarded</th>
                    <th className="text-center align-middle">Expiry</th>
                  </tr>
                </thead>

                <tbody>
                  {freeProductsTableRow.map((obj, i) =>
                    <tr key={i} className="offer-tr">
                      <td style={{backgroundImage: "url('" + obj.Image + "')", backgroundSize: "cover", backgroundColor: "black"}} className="offer-td point-cursor text-center align-middle" onClick={()=>openModal(obj.Description, obj.ProductDescription)}>
                        <h3 className="offer-heading align-middle">{obj.ProductDescription.toUpperCase()}</h3>
                      </td>
                      <td className="text-center align-middle">{obj.DateIssued}</td>
                      <td className="text-center align-middle">{obj.ExpiryDate}</td>
                    </tr>
                  )}
                </tbody>
            </table>
          </div>
          : (hideProducts === false) ?
          <div>
            <h3 className="text-center"><strong>Offers</strong></h3>
            <table className="table table-striped pointsTable">
                <tbody>
                  {freeProductsTableRow.map((obj, i) =>
                    <tr key={i} className="offer-tr">
                      <td style={{backgroundImage: "url('" + obj.Image + "')", backgroundSize: "cover", backgroundColor: "black"}} className="offer-td point-cursor text-center align-middle" onClick={()=>openModal(obj.Description, obj.ProductDescription, obj.ExpiryDate)}>
                        <h3 className="offer-heading align-middle">{obj.ProductDescription.toUpperCase()}</h3>
                      </td>
                    </tr>
                  )}
                </tbody>
            </table>
          </div>
          :
          <div>
          </div>
          } 

          <br/>
        
          <h3 className='text-center'><strong>Tier Information</strong></h3>
          <p className='text-justify'>Earn Reward Points for every $1 spent in our dining areas, bars, function areas, reception, Monkey Mania, gaming areas and Club Carwash (and all associated venues). Be sure to download the Bankstown Sports App so you can easily scan your digital card at any of our check outs. </p>
          <br/>
          <p>Your current tier level is: <strong>{pointsPoolData.tier}</strong></p>

          <br/>
          
          <div className="progressBar">
            <ProgressBar now={tierPercent}/>
            <ol className="progressPoints">
              <li className="progressPoint"><span className="goal basic-goal"></span><br/>Basic</li>
              <li className="progressPoint"><span className={bronzeGoal}></span><br/>Bronze</li>
              <li className="progressPoint"><span className={silverGoal}></span><br/>Silver</li>
              <li className="progressPoint"><span className={goldGoal}></span><br/>Gold</li>
              <li className="progressPoint"><span className={platinumGoal}></span><br/>Platinum</li>
              <li className="progressPoint"><span className={diamondGoal}></span><br/>Diamond</li>
            </ol>
          </div>

          <br/>
          <br/>
          <br/>
          <br/>

          <button className="form-btn btn btn-primary float-left formButton" onClick={redirectHome}>Back</button>
        </div>
        </div>
      );
}